import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AppState } from 'shared/store/reducers';
import { RejectError } from 'shared/api/axios';
import {
  createWidgetBackground,
  deleteWidgetBackground,
  getWidgetBackgrounds,
} from 'shared/api';
import { WidgetBackground } from 'types/designer-rules';

export const setNewWidgetBackground = createAsyncThunk<
  WidgetBackground,
  { old?: WidgetBackground; new: Omit<WidgetBackground, 'id'> },
  { state: AppState; rejectValue: RejectError }
>('designer/setNewWidgetBackground', async ({ old, new: data }) => {
  if (old) {
    await deleteWidgetBackground(old.id);
  }
  return (await createWidgetBackground(data)).data;
});

export const fetchWidgetBackgrounds = createAsyncThunk<
  WidgetBackground[],
  void,
  { state: AppState; rejectValue: RejectError }
>('designer/fetchWidgetBackgrounds', async () => {
  return (await getWidgetBackgrounds()).data;
});

export const removeWidgetBackground = createAsyncThunk<
  void,
  number,
  { state: AppState; rejectValue: RejectError }
>('designer/deleteWidgetBackground', async id => {
  return void (await deleteWidgetBackground(id));
});

export const initialState = {
  widgetBackgrounds: [] as WidgetBackground[],
};

// SLICE

const uiConfigSlice = createSlice({
  name: 'designer',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchWidgetBackgrounds.fulfilled, (state, action) => {
      state.widgetBackgrounds = action.payload;
    });

    builder.addCase(setNewWidgetBackground.fulfilled, (state, action) => {
      state.widgetBackgrounds = state.widgetBackgrounds.filter(
        b => b.id !== action.meta.arg.old?.id,
      );
      state.widgetBackgrounds.push(action.payload);
    });

    builder.addCase(removeWidgetBackground.fulfilled, (state, action) => {
      state.widgetBackgrounds = state.widgetBackgrounds.filter(
        b => b.id !== action.meta.arg,
      );
    });
  },
});

export default uiConfigSlice.reducer;
